
import { AgsRetriggerFreespinsState } from "ags/state-machine/states/ags-retrigger-freespins-state";
import { gameState } from "appworks/model/game-state";
import { PromptContentSubcomponent } from "appworks/components/prompt/prompt-content-subcomponent";
import {Components} from "appworks/components/components";
import { PromptComponent } from "appworks/components/prompt/prompt-component";
import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";
import { Services } from "appworks/services/services";
import { TranslationsService } from "appworks/services/translations/translations-service";


export class ThemeRetriggerFreespinsState extends AgsRetriggerFreespinsState {
    protected showPrompt(prompt?: PromptContentSubcomponent): void {
        const record: FreespinRecord = gameState.getCurrentGame().getCurrentRecord() as FreespinRecord;
        const retriggerTotal: number = record.getFreespinsWon()// - trailRetriggerTotal;
        if (retriggerTotal > 0) {
            prompt = new PromptContentSubcomponent(["freespinsretrigger"], 2000);
            prompt.setText("winMessage", Services.get(TranslationsService).getFirstValid(["extra_free_spins_awarded"], { VALUE: record.getFreespinsWon() }));
            prompt.addContinueButton("continue");
            Components.get(PromptComponent).showPrompt(prompt).then(() => this.complete());
        } else {
            this.complete();
        }
    }
}
